<template>
  <router-view/>
  <div class="restart-arrow" @click="toggleModal">
    <img src="@/assets/image/restart-arrow.png" alt="">
  </div>
  <teleport to="body">
    <!-- Modal goes here -->
    <div v-if="isModalOpen" class="modal restart">
        <div class="restart-headline">
          <img src="@/assets/image/restart-headline.png" alt="">
        </div>
        <div class="button-group">
          <div class="button" @click="restartPresentation">
            <img src="@/assets/image/restart-button-restart.png" alt="">
          </div>
          <div class="button"  @click="toggleModal">
            <img src="@/assets/image/restart-button-continue.png" alt="">
          </div>
        </div>
    </div>
  </teleport>
</template>

<script>
export default {
  data() {
    return {
      isModalOpen: false,
    }
  },
  methods: {
    toggleModal() {
      this.isModalOpen = !this.isModalOpen
    },
    restartPresentation() {
      this.toggleModal();
      this.$router.push({name: 'home'});
    }
  },
  mounted() {
    let swipedScript = document.createElement('script')
    swipedScript.setAttribute('src', '/js/swiped-events.min.js')
    document.head.appendChild(swipedScript)
  }
}
</script>

<style>
/*
YUI 3.18.1 (build f7e7bcb)
Copyright 2014 Yahoo! Inc. All rights reserved.
Licensed under the BSD License.
http://yuilibrary.com/license/
*/

html{color:#000;background:#071D49}body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td{margin:0;padding:0}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}address,caption,cite,code,dfn,em,strong,th,var{font-style:normal;font-weight:normal}ol,ul{list-style:none}caption,th{text-align:left}h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:normal}q:before,q:after{content:''}abbr,acronym{border:0;font-variant:normal}sup{vertical-align:text-top}sub{vertical-align:text-bottom}input,textarea,select{font-family:inherit;font-size:inherit;font-weight:inherit;*font-size:100%}legend{color:#000}

/* apply a natural box layout model to all elements, but allowing components to change */
html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}


html {
	font-size: 62.5%;
}

div, p {
  font-family: "Neue Haas Unica W1G", Arial, sans-serif;
}

label {
  display: block;
}

/* #app {
  width: 100vw;
  height: 56.25vw;
  margin-top: calc((100vh - 56.25vw) / 2);
  position: relative;
}

.page, .slide {
  width: 100vw;
  height: 56.25vw;
} 

.modal {
  position: absolute;
  top: calc((100vh - 56.25vw) / 2);
  bottom: 0;
  left: 0;
  right: 0;
  height: 56.25vw;
  z-index: 10000;
}

.next {
    position: absolute;
    top: calc(56.25vw - 2rem - 25px);
    right: 25px;
    font-size: 2rem;
    z-index: 100;
}
*/

#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

@supports (-webkit-touch-callout: none) {
  #app {
    max-height: -webkit-fill-available;
  }
}

.page, .slide {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  overflow: hidden;
}


.restart-arrow {
  position: absolute;
  top: 1vw;
  left: 0.94vw;
  width: 3.68vw;
  cursor: pointer;
  z-index: 1001;
}

#home-page + .restart-arrow {
  display: none;
}

.restart-arrow img {
  width: 100%;
  height: auto;
}

.modal {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
}

.modal.restart {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #071D49CC;
}

.modal.restart .restart-headline {
  width: 48.30vw;
}
.modal.restart .restart-headline img {
  width: 100%;
}

.modal.restart .button-group {
  display: flex;
  justify-content: space-between;
  width: 41vw;
  margin-top: 2.5vw;
}

.modal.restart .button {
  width: 19.87vw;
  cursor: pointer;
}

.modal.restart .button img {
  width: 100%;
}

.slide-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    overflow: hidden;
}
.slide-container, body {
    background: #071D49;
}

.next {
    position: absolute;
    bottom: 3vw;
    right: 3.67vw;
    font-size: 2rem;
    z-index: 100;
}

.illustration-container {
  background-image: url('@/assets/image/background-container.png');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 87.5vw;
  height: 31.25vw;
  position: absolute;
  top: 20.31vw;
  left: 6.25vw;
}
</style>
